module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/3/2-0dc4edd67352ff1e18dea9ba10f6124b.jpg";